import React from 'react'

import { ThemeProvider } from '@material-ui/styles'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import './styles/globalstyles.css'
import { Provider } from 'react-redux'

import AppRoutes from './routes'
import theme from './theme'
import { store } from './store'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'

import { ErrorBoundary } from './components/ErrorBoundary'
import { BrowserRouter, useLocation } from 'react-router-dom'
import { AuthProvider } from './contexts/auth/AuthProvider'

import 'swiper/css'
import 'swiper/css/pagination'

export const App: React.FC = () => {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        retry: false,
        refetchOnWindowFocus: false
      }
    }
  })
  return (
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <Provider store={store}>
          <ThemeProvider theme={theme}>
            <ToastContainer
              position='bottom-right'
              draggable
              rtl={false}
              pauseOnHover
              closeOnClick
              autoClose={3000}
              pauseOnFocusLoss
              newestOnTop={false}
              hideProgressBar={false}
              theme='colored'
            />
            <AuthProvider>
              <AppContent />
            </AuthProvider>
          </ThemeProvider>
        </Provider>
        {process.env.NODE_ENV === 'development' && <ReactQueryDevtools initialIsOpen={false} />}
      </QueryClientProvider>
    </BrowserRouter>
  )
}

const AppContent: React.FC = () => {
  const location = useLocation()
  return (
    <ErrorBoundary key={location.pathname}>
      <AppRoutes />
    </ErrorBoundary>
  )
}

export default App
